import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import { PropsWithChildren, useEffect, useState } from "react";
import { InjectedProps } from "redux-modal";
import styles from "./EditTemplateModal.module.scss";
import Icon from "@components/global/new/Icon/Icon";
import remove from "@assets/redesign/icons/remove.svg";
import { Input } from "@components/global/new/Input/Input";
import { Button } from "antd";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import classNames from "classnames";

const MAX_LENGTH_VALUE = 100;

type EditTemplateModalProps = {
  createNew?: boolean;
  name?: string;
  onApply?: { (name: string): void };
  onDelete?: { (): void };
} & CommonModalPropsI &
  PropsWithChildren<InjectedProps>;

function EditTemplateModal(props: EditTemplateModalProps) {
  const [value, setValue] = useState(props.name || "");
  const [char, setChar] = useState(value.length);
  const { onError } = useGlobalNotifs();

  useEffect(() => {
    setChar(value.length);
  }, [value]);

  return (
    <div className={styles.wrap}>
      <div className={styles.title}>
        <h4>
          {props.formatMessage({
            id: props.createNew
              ? "modal.editTemplate.title.add"
              : "modal.editTemplate.title.edit",
          })}
        </h4>
        {props.onDelete && !props.createNew ? (
          <span
            onClick={() => {
              props.onDelete!();
              props.handleClose();
            }}
          >
            <Icon src={remove} noHover />
            <span>
              {props.formatMessage({
                id: "modal.editTemplate.actions.deleteTemplate",
              })}
            </span>
          </span>
        ) : null}
      </div>
      <Input
        label={
          <div className={styles.labelWrapper}>
            <span className={styles.label}>
              {props.formatMessage({ id: "modal.editTemplate.title.name" })}
            </span>
            <div
              className={classNames(styles.maxChar, {
                [styles.error]: value.length >= MAX_LENGTH_VALUE,
              })}
            >
              ({char}/{MAX_LENGTH_VALUE})
            </div>
          </div>
        }
        placeholder={props.formatMessage({
          id: "modal.editTemplate.title.enterName",
        })}
        outlined
        value={value}
        onChange={(e) => setValue(e.currentTarget.value)}
      />

      <div className={styles.buttons}>
        <Button onClick={props.handleClose}>
          {props.formatMessage({ id: "modal.editTemplate.actions.cancel" })}
        </Button>
        <Button
          type="primary"
          onClick={() => {
            if (value.length < 5) {
              onError(
                props.formatMessage({
                  id: "manage.tags.managment.error.tag_name_too_short",
                })
              );
            } else if (value.length > 100) {
              onError(
                props.formatMessage({
                  id: "manage.tags.managment.error.tag_name_too_long",
                })
              );
            } else {
              props.onApply?.(value);
              props.handleClose();
            }
          }}
        >
          {props.formatMessage({
            id: props.createNew
              ? "modal.editTemplate.actions.add"
              : "modal.editTemplate.actions.save",
          })}
        </Button>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.EDIT_TEMPLATE, EditTemplateModal);
